module.exports = __webpack_public_path__ + "static/img/138.c992bb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/138.png
// module id = EBJw
// module chunks = 0